// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { liskSepolia as _liskSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the liskSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4202
 * Chain Name: Lisk Sepolia
 * Default Block Explorer: https://sepolia-blockscout.lisk.com
 * Default RPC URL: https://rpc.sepolia-api.lisk.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { liskSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: liskSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const liskSepolia = createCommon({
	..._liskSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
